export default __webpack_public_path__ + "static/media/RTR1802V_LateralIzq.0938529c.webp";